/**
 * Логотип SKOKA — по макету «skoka-logo-light» (Figma, узел 21:127).
 *
 * Две части, как в макете: написание и искры. Файлы взяты из макета как
 * есть (`assets/brand`), расставлены по его рамке 188 × 65: написание снизу
 * слева, искры сверху справа. Написание в макете отражено по вертикали —
 * так же отражено и здесь, иначе буквы встали бы вверх ногами.
 *
 * Тёмная тема: буквы светлеют фильтром, искры остаются фирменными — у них
 * свой файл, и фильтр их не касается.
 */
import word from './assets/brand/skoka-word.svg';
import spark from './assets/brand/skoka-spark.svg';

export function Wordmark({ pro }: { pro?: boolean } = {}) {
  return (
    <div className="wordmark">
      <span className="logo" role="img" aria-label="SKOKA">
        <span className="logo-word"><img src={word} width={175.096} height={36.4415} alt="" /></span>
        <span className="logo-spark"><span><img src={spark} width={29.516} height={30.6438} alt="" /></span></span>
      </span>
      {pro && <b className="pro-chip">PRO</b>}
    </div>
  );
}
